import { render, staticRenderFns } from "./MoreJoinDetailDialog.vue?vue&type=template&id=6a3b98ae&scoped=true&"
import script from "./MoreJoinDetailDialog.vue?vue&type=script&lang=js&"
export * from "./MoreJoinDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./MoreJoinDetailDialog.vue?vue&type=style&index=0&id=6a3b98ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b98ae",
  null
  
)

export default component.exports